import { Injectable } from '@angular/core';

export interface Week {
  start: string;
  end: string;
}

@Injectable({ providedIn: 'root' })
export class DatafilterService {
  getMonths(): { name: string; value: number }[] {
    return [
      { name: 'All', value: 0 },
      ...Array.from({ length: 12 }, (_, i) => ({
        name: new Date(2000, i, 1).toLocaleString('default', { month: 'long' }),
        value: i + 1,
      })),
    ];
  }

  getWeeks(year: number, month: number): Week[] {
    const weeks: Week[] = [];
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);
    let current = new Date(firstDay);

    while (current <= lastDay) {
      const weekStart = new Date(current);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekEnd.getDate() + (6 - weekEnd.getDay()));

      if (weekEnd > lastDay) {
        weekEnd.setTime(lastDay.getTime());
      }

      weeks.push({
        start: weekStart.toISOString().split('T')[0],
        end: weekEnd.toISOString().split('T')[0],
      });

      current.setDate(weekEnd.getDate() + 1);
    }

    return weeks;
  }

  getAllWeeksByMonth(year: number): { [key: string]: Week[] } {
    const result: { [key: string]: Week[] } = {};
    for (let month = 1; month <= 12; month++) {
      result[`${year}-${month}`] = this.getWeeks(year, month);
    }
    return result;
  }
}
